import { BookmarkActionViewMode } from '../types/api';
import { User } from '../types/api';

export type DownloadFormat = 'kindle' | 'epub' | 'printable' | 'rss';
export type DownloadSectionType = BookmarkActionViewMode;

export function generateFileDownloadURL(
  mode: string,
  format: 'epub' | 'pdf',
  folderId?: string,
  tagSlug?: string,
): string | null {
  const canExportFiles = ['home', 'unread', 'folder', 'tags'].includes(mode);
  if (!canExportFiles) {
    return null;
  }
  const url = `/user/download/${format}`;
  const params = new URLSearchParams();
  params.set('success_url', window.location.href);
  if (folderId) {
    params.set('folder_id', folderId);
  } else if (tagSlug) {
    params.set('tag', tagSlug);
  }
  return `${url}?${params.toString()}`;
}

export function generateEPubDownloadURL(
  mode: string,
  folderId?: string,
  tagSlug?: string,
): string | null {
  return generateFileDownloadURL(mode, 'epub', folderId, tagSlug);
}

export function generatePDFDownloadURL(
  mode: string,
  folderId?: string,
  tagSlug?: string,
): string | null {
  return generateFileDownloadURL(mode, 'pdf', folderId, tagSlug);
}

export function generateRSSDownloadURL(
  mode: string,
  currentUser?: User,
  folderId?: string,
  tagSlug?: string,
): string | null {
  if (!currentUser) {
    return null;
  }
  if (['home', 'unread'].includes(mode)) {
    return `/rss/${currentUser.id}/${currentUser.rssKey}`;
  }
  if (['liked', 'archive', 'videos'].includes(mode)) {
    return `/${mode}/rss/${currentUser.id}/${currentUser.rssKey}`;
  } else if (mode == 'folder' && folderId) {
    return `/folder/${folderId}/rss/${currentUser.id}/${currentUser.rssKey}`;
  } else if (mode == 'tags' && tagSlug) {
    return `/tags/${tagSlug}/rss/${currentUser.id}/${currentUser.rssKey}`;
  }
  return null;
}

/**
 * Check if user has Kindle configured
 * This would typically be part of user settings/preferences
 */
export async function hasKindleConfigured(): Promise<boolean> {
  try {
    // TODO: Replace with actual API endpoint when available
    // For now, assume Kindle is configured if user is logged in
    return true;
  } catch {
    return false;
  }
}
